import { useHistory } from "react-router-dom";
import { baseURL } from "../../../basics";
import { useDispatch, useSelector } from "react-redux";
import { categoryActions } from "../../../store/category-slice";
import { fetchShowProductsHandler } from "../../../store/category-actions";

const ListOfCategoriesData = (props: any) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const itemsPerPage = useSelector((state: any) => state.category.itemsPerPage);
  const currentPage = useSelector((state: any) => state.category.page);
  const categoryId = useSelector((state: any) => state.category.categoryId);
  const typeOfProductsCategories = useSelector(
    (state: any) => state.category.typeOfProductsCategories
  );
  const isActive = typeOfProductsCategories === "" && categoryId === props.id;
  const clickOnCategoryItemHandler = () => {
    // console.log("props.id", props.id);
    // console.log('clickOnCategoryItemHandler',props.id);
    dispatch(categoryActions.newCategoryIsSelected());
    dispatch(categoryActions.typeOfProductsCategoriesChanger(""));
    // dispatch(fetchShowProductsHandler(currentPage, itemsPerPage, props.id));
    dispatch(categoryActions.idOfSelectedCategory(props.id));
    history.push("/products");
  };
  return (
    <div
      onClick={clickOnCategoryItemHandler}
      className={`flex flex-col items-center justify-center gap-1 sm:gap-1.5 w-full h-24 sm:h-32 rounded-2xl cursor-pointer p-1 sm:p-2.5 border transition ${
        isActive
          ? "bg-orange-50 border-orange-200 shadow-sm"
          : "bg-white border-slate-100 hover:border-emerald-200 hover:bg-emerald-50/40 hover:shadow-sm"
      }`}
    >
      <img
        src={`${baseURL}${props.imageUrl}`}
        alt={props.name}
        className="h-9 w-9 sm:h-12 sm:w-12 object-contain"
      />
      <p
        className="text-[11px] sm:text-xs font-semibold text-gray-900 text-center leading-4 sm:leading-5"
        style={{
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
        }}
      >
        {props.name}
      </p>
    </div>
  );
};
export default ListOfCategoriesData;
